import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/Layout'

const Terms = ({location}) => (
  <Layout location={location}>
    <SEO title="Terms" />
    <h1>Terms</h1>
    <p>
      Lorem ipsizzle dolizzle sit amizzle, fo shizzle my nizzle adipiscing
      elizzle. Pizzle mah nizzle velizzle, owned volutpizzle, mammasay mammasa
      mamma oo sa quizzle, my shizz uhuh ... yih!, shit. Pellentesque nizzle for
      sure. erizzle. Cool shiznit dolizzle dapibizzle turpis tempizzle tempor.
      Get down get down bow wow wow nibh the bizzle turpizzle. Fo shizzle mah
      nizzle fo rizzle, mah home g-dizzle izzle go to hizzle. Pellentesque for
      sure rhoncizzle sure. In yippiyo habitasse platea dictumst. Shizzle my
      nizzle crocodizzle dapibizzle. Curabitur tellus ass, pretizzle away,
      gangsta ac, eleifend vitae, shizzlin dizzle. Mammasay mammasa mamma oo sa
      suscipizzle. Shizzle my nizzle crocodizzle semper velit sed purizzle.
    </p>
  </Layout>
)

export default Terms
